import { keyframes, Stack, Typography, useTheme } from "@mui/material";
import { AiStarIcon } from "components/icons/AiStarIcon";

const shimmer = keyframes`
  0% { background-position: 0% 50%; }
  100% { background-position: 200% 50%; }
`;

/**
 * Spinning star + shimmering gradient text — Helena "working" treatment.
 * Shared by the thread's status row ("Helena is typing...") and the
 * dictation box ("Listening...").
 */
export const AskHelenaShimmerLabel = ({ label }: { label: string }) => {
  const theme = useTheme();

  return (
    <Stack
      direction="row"
      sx={{ gap: "8px", alignItems: "center", alignSelf: "flex-start" }}
    >
      <AiStarIcon
        className="ai-star-spin"
        sx={{
          width: 8,
          height: 8,
          color: theme.palette.primitive.system.violet[800],
        }}
      />
      <Typography
        variant="body-small"
        sx={{
          background:
            "linear-gradient(90deg, #4D25ED, #874FFF, #FAF8FA, #FF96E2, #ED25C1, #FF96E2, #FAF8FA, #874FFF, #4D25ED)",
          backgroundSize: "200% 100%",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          animation: `${shimmer} 1.5s infinite alternate ease-in-out`,
        }}
      >
        {label}
      </Typography>
    </Stack>
  );
};
